module.exports = __webpack_public_path__ + "img/blue.577aff0a.svg";